// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Cluster
 */
export interface Cluster {
  /**
   * Annotations carries the cluster's annotations.
   * @type {{ [key: string]: string; }}
   * @memberof Cluster
   */
  annotations?: { [key: string]: string };
  /**
   * IsolationUnitId is the isolation unit this cluster belongs to.
   * @type {string}
   * @memberof Cluster
   */
  isolationUnitId?: string;
  /**
   *
   * @type {string}
   * @memberof Cluster
   */
  name: string;
  /**
   * PartitionName is the environment partition this cluster belongs to, if any.
   * @type {string}
   * @memberof Cluster
   */
  partitionName?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Cluster
   */
  roles: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Cluster
   */
  zones?: Array<string>;
}

/**
 * Check if a given object implements the Cluster interface.
 */
export function instanceOfCluster(value: object): value is Cluster {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('roles' in value) || value['roles'] === undefined) return false;
  return true;
}

export function ClusterFromJSON(json: any): Cluster {
  return ClusterFromJSONTyped(json, false);
}

export function ClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Cluster {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    isolationUnitId:
      json['isolation_unit_id'] == null ? undefined : json['isolation_unit_id'],
    name: json['name'],
    partitionName:
      json['partition_name'] == null ? undefined : json['partition_name'],
    roles: json['roles'],
    zones: json['zones'] == null ? undefined : json['zones'],
  };
}

export function ClusterToJSON(json: any): Cluster {
  return ClusterToJSONTyped(json, false);
}

export function ClusterToJSONTyped(
  value?: Cluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    isolation_unit_id: value['isolationUnitId'],
    name: value['name'],
    partition_name: value['partitionName'],
    roles: value['roles'],
    zones: value['zones'],
  };
}
